export enum TodoActionTypes {
  SHOW_DELETE_CONFIRMATION_MODAL = '[Todo] Show Delete Confirmation Modal',
  HIDE_DELETE_CONFIRMATION_MODAL = '[Todo] Hide Delete Confirmation Modal',
  SHOW_TODO_DROPDOWN = '[Todo] Show Todo Dropdown',
  HIDE_TODO_DROPDOWN = '[Todo] Hide Todo Dropdown',
}

type TodoActions =
  | { type: TodoActionTypes.SHOW_DELETE_CONFIRMATION_MODAL; payload: number }
  | { type: TodoActionTypes.HIDE_DELETE_CONFIRMATION_MODAL }
  | { type: TodoActionTypes.SHOW_TODO_DROPDOWN }
  | { type: TodoActionTypes.HIDE_TODO_DROPDOWN };

interface TodoReducerState {
  showTodoDropdown: boolean;
  showDeleteConfirmationModal: boolean;
  selectedId: number | null;
}

export function reducer(state, action: TodoActions): TodoReducerState {
  switch (action.type) {
    case TodoActionTypes.SHOW_DELETE_CONFIRMATION_MODAL:
      return {
        ...state,
        showDeleteConfirmationModal: true,
        selectedId: action.payload,
      };
    case TodoActionTypes.HIDE_DELETE_CONFIRMATION_MODAL:
      return {
        ...state,
        showDeleteConfirmationModal: false,
        selectedId: null,
      };
    case TodoActionTypes.SHOW_TODO_DROPDOWN:
      return {
        ...state,
        showTodoDropdown: true,
      };
    case TodoActionTypes.HIDE_TODO_DROPDOWN:
      return {
        ...state,
        showTodoDropdown: false,
      };
    default:
      return state;
  }
}
